import React from 'react';
import { RegisterOptions, DeepMap, FieldError } from 'react-hook-form';

interface props {
  name: string;
  className?: string;
  register: any;
  rules?: RegisterOptions;
  errors: DeepMap<any, FieldError>;
  placeholder?: string;
  onBlur?: (event: any) => void;
  disabled?: boolean;
}

export const TextBox: React.FC<props> = ( { name, className, register, rules, errors, placeholder, onBlur, disabled } ) => {
  return (
    <>
      <input type="text" name={name} className={className} {...register(name, rules)} placeholder={placeholder} onBlur={onBlur} disabled={disabled}/>
      {/*{errors[name] && <p>{errors[name].message}</p>}*/}
    </>
  );
};